import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Airbnb from "../../../assets/svg/Airbnbfirststep.svg?react";
import CheckCircle from "../../../assets/svg/circle-check.svg?react";
import { useNavigate } from "react-router-dom";

const EmptyState = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  const navigate = useNavigate();
  return (
    <section>
      <Box
        sx={{
          width: "100%",
          direction: isRtl ? "rtl" : "ltr",
          height: "55px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          marginBottom: "46px",
        }}
      >
        <Typography
          sx={{
            typography: "h6",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "24px",
            letterSpacing: "0%",
            textTransform: "capitalize",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          {t("Automation.MessageAutomationManagementHeader")}
        </Typography>
        <Typography
          sx={{
            typography: "body1",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "19.2px",
            letterSpacing: "0%",
            direction: isRtl ? "rtl" : "ltr",
            color: "#ADBAC7",
            paddingTop: "10px",
          }}
        >
          {t("Automation.MessageAutomationManagementSubheader")}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "653px",
          top: "188px",
          left: "24px",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Airbnb
          style={{
            width: "164px",
            height: "74px",
          }}
        />
        <Typography
          sx={{
            width: "fit-content",
            marginTop: "32px",
            typography: "h1",
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "28.8px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          {t("Automation.SignUpWithAirbnb")}
          <span style={{ color: "#5B3FFF" }}>
            {t("Automation.SignUpWithAirbnbSpan")}
          </span>
        </Typography>{" "}
        <Typography
          sx={{
            width: "508px",
            fontWeight: 400,
            fontSize: "14px",
            leading: "Cap height",
            lineHeight: "16.8px",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#625783",
            marginTop: "12px",
          }}
        >
          {t("Automation.MakeManagingPropertiesEasier")}
        </Typography>
        <Button
          onClick={() => {
            navigate("/properties-management");
          }}
          sx={{
            marginTop: "32px",
            fontSize: "14px",
            width: "200px",
            height: "41px",
            padding: "16px",
            gap: "10px",
            borderRadius: "8px",
            backgroundColor: "#5B3FFF",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#5B3FFF",
            },
          }}
        >
          {t("Automation.ConnectWithAirbnb")}
        </Button>
        <Typography
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "16px",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14.4px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          <CheckCircle />
          {t("Automation.AutomaticSynchronization")}
        </Typography>{" "}
        <Typography
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "13px",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14.4px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          <CheckCircle />
          {t("Automation.ManageCalendarEasily")}
        </Typography>{" "}
        <Typography
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "13px",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14.4px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          <CheckCircle />
          {t("Automation.FinancialPerformanceMonitoring")}
        </Typography>{" "}
        <Typography
          sx={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "13px",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14.4px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          <CheckCircle />
          {t("Automation.InstantUpdates")}
        </Typography>
      </Box>
    </section>
  );
};

export default EmptyState;
